import * as moment from "moment";
import { parse } from "querystring";

const titlecase = (str) =>
  str
    ? str
        .split(" ")
        .map((a) => a.charAt(0).toUpperCase() + a.slice(1).toLowerCase())
        .join(" ")
    : "";

const rowTemplate = (payment, i, details = "extra_text") => {
  const paidAmount = payment.total_amount - +payment.remaining_amount;
  return `
  <tr>
    <td>${i + 1}</td>
    <td>${titlecase(payment.payment_title)}</td>
    <td>${payment[details] || ""}</td>
    <td>${parseInt(payment.amount_before_taxes).toLocaleString("en-US")}</td>
    <td>${parseInt(payment.taxes_amount).toLocaleString("en-US")} (${
    payment.taxes_percentage
  }%)</td>
  <td>${parseInt(payment.total_amount).toLocaleString("en-US")}</td>
  <td>${paidAmount.toLocaleString("en-US")}</td>
  <td>${parseInt(payment.remaining_amount).toLocaleString("en-US")}</td>
  </tr>
  `;
};

export const printClaim = ({ base }, reservation, payments: any[]) => {
  // data
  const tables_data = {
    installment: {
      data: [],
      totals: {
        amount: 0,
        tax: 0,
        total: 0,
        remaining_total: 0,
        paid_total: 0,
      },
    },
    insurance: {
      data: [],
      totals: {
        amount: 0,
        tax: 0,
        total: 0,
        remaining_total: 0,
        paid_total: 0,
      },
    },
    markting: {
      data: [],
      totals: {
        amount: 0,
        tax: 0,
        total: 0,
        remaining_total: 0,
        paid_total: 0,
      },
    },
    maintenance: {
      data: [],
      totals: {
        amount: 0,
        tax: 0,
        total: 0,
        remaining_total: 0,
        paid_total: 0,
      },
    },
    others: {
      data: [],
      totals: {
        amount: 0,
        tax: 0,
        total: 0,
        remaining_total: 0,
        paid_total: 0,
      },
    },
    fines: {
      data: [],
      totals: {
        amount: 0,
        tax: 0,
        total: 0,
        remaining_total: 0,
        paid_total: 0,
      },
    },
  };

  // prepare data
  //console.log(payments);
  payments.map((payment) => {
    if (
      payment.payment_type === "Installment" ||
      payment.payment_type === "Down Payment" || 
      payment.payment_type === "Rent"
    ) {
      tables_data.installment.data.push(
        rowTemplate(
          payment,
          tables_data.installment.data.length,
          "payment_date"
        )
      );
      tables_data.installment.totals.amount +=
        +payment.amount_before_taxes || 0;
      tables_data.installment.totals.tax += +payment.taxes_amount || 0;
      tables_data.installment.totals.total += +payment.total_amount || 0;
      tables_data.installment.totals.remaining_total +=
        +payment.remaining_amount || 0;
      tables_data.installment.totals.paid_total +=
        +payment.total_amount - +payment.remaining_amount || 0;
    } else if (payment.payment_type === "Extra") {
      tables_data.maintenance.data.push(
        rowTemplate(payment, tables_data.maintenance.data.length)
      );
      tables_data.maintenance.totals.amount +=
        +payment.amount_before_taxes || 0;
      tables_data.maintenance.totals.tax += +payment.taxes_amount || 0;
      tables_data.maintenance.totals.total += +payment.total_amount || 0;
      tables_data.maintenance.totals.remaining_total +=
        +payment.remaining_amount || 0;
      tables_data.maintenance.totals.paid_total +=
        +payment.total_amount - +payment.remaining_amount || 0;
    } else if (payment.type === "Claim") {
      if (payment.payment_title === "marketing fees") {
        tables_data.markting.data.push(
          rowTemplate(payment, tables_data.markting.data.length)
        );
        tables_data.markting.totals.amount += +payment.amount_before_taxes || 0;
        tables_data.markting.totals.tax += +payment.taxes_amount || 0;
        tables_data.markting.totals.total += +payment.total_amount || 0;
        tables_data.markting.totals.remaining_total +=
          +payment.remaining_amount || 0;
        tables_data.markting.totals.paid_total +=
          +payment.total_amount - +payment.remaining_amount || 0;
      } else if (
        payment.payment_title === "maintenance difference" ||
        payment.payment_title === "other_maintenance"
      ) {
        tables_data.maintenance.data.push(
          rowTemplate(payment, tables_data.maintenance.data.length)
        );
        tables_data.maintenance.totals.amount +=
          +payment.amount_before_taxes || 0;
        tables_data.maintenance.totals.tax += +payment.taxes_amount || 0;
        tables_data.maintenance.totals.total += +payment.total_amount || 0;
        tables_data.maintenance.totals.remaining_total +=
          +payment.remaining_amount || 0;
        tables_data.maintenance.totals.paid_total +=
          +payment.total_amount - +payment.remaining_amount || 0;
      } else {
        tables_data.others.data.push(
          rowTemplate(payment, tables_data.others.data.length)
        );
        tables_data.others.totals.amount += +payment.amount_before_taxes || 0;
        tables_data.others.totals.tax += +payment.taxes_amount || 0;
        tables_data.others.totals.total += +payment.total_amount || 0;
        tables_data.others.totals.remaining_total +=
          +payment.remaining_amount || 0;
        tables_data.others.totals.paid_total +=
          +payment.total_amount - +payment.remaining_amount || 0;
      }
    } else if (payment.payment_type == "Fine") {
      tables_data.fines.data.push(
        rowTemplate(payment, tables_data.fines.data.length)
      );
      tables_data.fines.totals.amount += +payment.amount_before_taxes || 0;
      tables_data.fines.totals.tax += +payment.taxes_amount || 0;
      tables_data.fines.totals.total += +payment.total_amount || 0;
      tables_data.fines.totals.remaining_total +=
        +payment.remaining_amount || 0;
      tables_data.fines.totals.paid_total +=
        +payment.total_amount - +payment.remaining_amount || 0;
    } else if (payment.payment_type == "Insurance") {
      tables_data.insurance.data.push(
        rowTemplate(payment, tables_data.insurance.data.length)
      );
      tables_data.insurance.totals.amount += +payment.amount_before_taxes || 0;
      tables_data.insurance.totals.tax += +payment.taxes_amount || 0;
      tables_data.insurance.totals.total += +payment.total_amount || 0;
      tables_data.insurance.totals.remaining_total +=
        +payment.remaining_amount || 0;
      tables_data.insurance.totals.paid_total +=
        +payment.total_amount - +payment.remaining_amount || 0;
    }
  });

  return `<!DOCTYPE html>
  <html lang="ar" dir="rtl">
    <head>
      <meta charset="UTF-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Reservation #${reservation.id}</title>

      <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@200;300;400;500;700;800;900;1000&display=swap" rel="stylesheet">
      <link rel="stylesheet" href="${base}assets/css/vendor/bootstrap.rtl.min.css" />
      <style>
        body {
          font-size: 14px;
          font-family: 'Cairo', sans-serif;
        }

        p {
          margin: 0;
        }

        #logo {
          width: 90%;
          max-height: 100%;
        }

        .bg-secondary {
          background-color: #bfbfbf !important;
        }
        @media print {
          * {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        }

        /* font-sizes */
        .fs-14px {
          font-size: 14px !important;
        }
        .fs-16px {
          font-size: 16px !important;
        }
        .fs-18px {
          font-size: 18px !important;
        }
        .fs-20px {
          font-size: 20px !important;
        }
        .fs-20px {
          font-size: 20px;
        }

        .table-template {
          page-break-after:auto
        }
      </style>
    </head>
    <body class="bg-light pt-3">
      <div class="container">
        <div class="row">
          <div class="col-8">
            <p class="lead text-center">${
              reservation.unit.project.developer.name
            }</p>
            <p class="lead text-center">( شركة مساهمة مصرية )</p>
          </div>
          <div class="col-4">
            <img src="${base}assets/img/ww-logo.png" alt="" id="logo" class="d-block m-auto" />
          </div>
        </div>
        <p class="lead line-underline text-center mt-3">
          مطالبة مجمعه بقيمة المستحقات على العميل
        </p>

        <hr />

        <div class="d-flex flex-column">
          <p class="lead fs-16px"><b>اسم العميل:</b> ${
            reservation.lead_name
          }</p>

          <p class="lead fs-16px"><b>رقم الوحدة:</b> ${
            reservation.unit ? reservation.unit.serial : "-"
          }</p>

          <p class="lead fs-16px"><b>مساحة الوحدة ( الداخلية ):</b> ${
            reservation.rent_details
              ? reservation.rent_details
                ? reservation.rent_details.indoor_area
                : 0
              : reservation.build_area
              ? reservation.build_area
              : 0
          }m<sup>2</sup></p>

          

          ${
            reservation.rent_details && reservation.rent_details.outdoor_area
              ? `
              <p class="lead fs-16px"><b>مساحة الوحدة ( الخارجية ):</b> ${reservation.rent_details.outdoor_area}m<sup>2</sup></p>
            `
              : ""
          }

          ${
            !reservation.rent_details && reservation.outdoor_area
              ? `
              <p class="lead fs-16px"><b>مساحة الوحدة ( الخارجية ):</b> ${reservation.outdoor_area}m<sup>2</sup></p>
            `
              : ""
          }

          <p class="lead fs-16px"><b>تاريخ المطالبة: </b> ${moment().format(
            "YYYY-MM-DD"
          )}</p>
          <p class="lead fs-16px"><b>المشروع: </b> ${
            reservation.unit.project.arabic_name
              ? reservation.unit.project.arabic_name
              : reservation.unit.project.name
          }</p>
        </div>
        ${
          tables_data.installment.data.length
            ? `
        <!-- Rent Data -->
        <div class="table-template mt-4">
          <div class="table-header ps-3 py-2 fs-5 bg-secondary">
            القيمة الإيجارية
          </div>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>م</th>
                  <th>البيان</th>
                  <th>تاريخ الشيك</th>
                  <th>القيمة الايجارية</th>
                  <th>ضريبة</th>
                  <th>الاجمالى</th>
                  <th>المدفوع</th>
                  <th>المتبقي</th>
                </tr>
              </thead>
              <tbody>
              ${tables_data.installment.data.join("")}
                <tr>
                  <th colspan="3">الاجمالى</th>
                  <th>${tables_data.installment.totals.amount.toLocaleString(
                    "en-US"
                  )}</th>
                  <th>${tables_data.installment.totals.tax}</th>
                  <th>${tables_data.installment.totals.total.toLocaleString(
                    "en-US"
                  )}</th>
                  <th>${tables_data.installment.totals.paid_total.toLocaleString(
                    "en-US"
                  )}</th>
                  <th>${tables_data.installment.totals.remaining_total.toLocaleString(
                    "en-US"
                  )}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        `
            : ""
        }

        ${
          tables_data.markting.data.length
            ? `
        <!-- Markting -->
        <div class="table-template mt-4">
          <div class="table-header ps-3 py-2 fs-5 bg-secondary">
            مصاريف الدعايا والتسويق
          </div>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>م</th>
                  <th>البيان</th>
                  <th>وصف</th>
                  <th>القيمة</th>
                  <th>ضريبة</th>
                  <th>الاجمالى</th>
                  <th>المدفوع</th>
                  <th>المتبقي</th>
                </tr>
              </thead>
              <tbody>
                ${tables_data.markting.data.join("")}
                <tr>
                  <th colspan="3">الاجمالى</th>
                  <th>${tables_data.markting.totals.amount.toLocaleString(
                    "en-US"
                  )}</th>
                  <th>${tables_data.markting.totals.tax}</th>
                  <th>${tables_data.markting.totals.total.toLocaleString(
                    "en-US"
                  )}</th>
                  <th>${tables_data.markting.totals.paid_total.toLocaleString(
                    "en-US"
                  )}</th>
                  <th>${tables_data.markting.totals.remaining_total.toLocaleString(
                    "en-US"
                  )}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        `
            : ""
        }

        ${
          tables_data.maintenance.data.length
            ? `
        <!-- Markting -->
        <div class="table-template mt-4">
          <div class="table-header ps-3 py-2 fs-5 bg-secondary">
            مصاريف الصيانة (تصدر بأسم شركة دبليو للصيانة )
          </div>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>م</th>
                  <th>البيان</th>
                  <th>وصف</th>
                  <th>القيمة</th>
                  <th>ضريبة</th>
                  <th>الاجمالى</th>
                  <th>المدفوع</th>
                  <th>المتبقي</th>
                </tr>
              </thead>
              <tbody>
                ${tables_data.maintenance.data.join("")}
                <tr>
                  <th colspan="3">الاجمالى</th>
                  <th>${tables_data.maintenance.totals.amount.toLocaleString(
                    "en-US"
                  )}</th>
                  <th>${tables_data.maintenance.totals.tax}</th>
                  <th>${tables_data.maintenance.totals.total.toLocaleString(
                    "en-US"
                  )}</th>
                  <th>${tables_data.maintenance.totals.paid_total.toLocaleString(
                    "en-US"
                  )}</th>
                  <th>${tables_data.maintenance.totals.remaining_total.toLocaleString(
                    "en-US"
                  )}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        `
            : ""
        }

        ${
          tables_data.insurance.data.length
            ? `
            <!-- Insurance -->
            <div class="table-template mt-4">
              <div class="table-header ps-3 py-2 fs-5 bg-secondary">
              تأمين
              </div>
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>م</th>
                      <th>البيان</th>
                      <th>وصف</th>
                      <th>القيمة</th>
                      <th>ضريبة</th>
                      <th>الاجمالى</th>
                      <th>المدفوع</th>
                      <th>المتبقي</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${tables_data.insurance.data.join("")}
                    <tr>
                      <th colspan="3">الاجمالى</th>
                      <th>${tables_data.insurance.totals.amount.toLocaleString(
                        "en-US"
                      )}</th>
                      <th>${tables_data.insurance.totals.tax}</th>
                      <th>${tables_data.insurance.totals.total.toLocaleString(
                        "en-US"
                      )}</th>
                      <th>${tables_data.insurance.totals.paid_total.toLocaleString(
                        "en-US"
                      )}</th>
                      <th>${tables_data.insurance.totals.remaining_total.toLocaleString(
                        "en-US"
                      )}</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
        `
            : ""
        }

        ${
          tables_data.fines.data.length
            ? `
            <!-- fines -->
            <div class="table-template mt-4">
              <div class="table-header ps-3 py-2 fs-5 bg-secondary">
              غرامات
              </div>
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>م</th>
                      <th>البيان</th>
                      <th>وصف</th>
                      <th>القيمة</th>
                      <th>ضريبة</th>
                      <th>الاجمالى</th>
                      <th>المدفوع</th>
                      <th>المتبقي</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${tables_data.fines.data.join("")}
                    <tr>
                      <th colspan="3">الاجمالى</th>
                      <th>${tables_data.fines.totals.amount.toLocaleString(
                        "en-US"
                      )}</th>
                      <th>${tables_data.fines.totals.tax}</th>
                      <th>${tables_data.fines.totals.total.toLocaleString(
                        "en-US"
                      )}</th>
                      <th>${tables_data.fines.totals.paid_total.toLocaleString(
                        "en-US"
                      )}</th>
                      <th>${tables_data.fines.totals.remaining_total.toLocaleString(
                        "en-US"
                      )}</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
        `
            : ""
        }

        ${
          tables_data.others.data.length
            ? `
            <!-- Others -->
            <div class="table-template mt-4">
              <div class="table-header ps-3 py-2 fs-5 bg-secondary">
                مصروفات اخرى
              </div>
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>م</th>
                      <th>البيان</th>
                      <th>وصف</th>
                      <th>القيمة</th>
                      <th>ضريبة</th>
                      <th>الاجمالى</th>
                      <th>المدفوع</th>
                      <th>المتبقي</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${tables_data.others.data.join("")}
                    <tr>
                      <th colspan="3">الاجمالى</th>
                      <th>${tables_data.others.totals.amount.toLocaleString(
                        "en-US"
                      )}</th>
                      <th>${tables_data.others.totals.tax}</th>
                      <th>${tables_data.others.totals.total.toLocaleString(
                        "en-US"
                      )}</th>
                      <th>${tables_data.others.totals.paid_total.toLocaleString(
                        "en-US"
                      )}</th>
                      <th>${tables_data.others.totals.remaining_total.toLocaleString(
                        "en-US"
                      )}</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
        `
            : ""
        }

        <div id="footer">
          <div class="row">
            <div class="col-6">
              اجمالي الشيك المطلوب لشركة ${
                reservation.unit.project.developer.name
              }:
            </div>
            <div class="col-3">${(
              tables_data.installment.totals.total +
              tables_data.insurance.totals.total +
              tables_data.markting.totals.total +
              tables_data.others.totals.total
            ).toLocaleString("en-US")}</div>
          </div>
          <div class="row">
            <div class="col-6">اجمالي الشيك المطلوب لشركة دبليو للصيانة:</div>
            <div class="col-3">${(
              tables_data.maintenance.totals.remaining_total +
              tables_data.fines.totals.remaining_total
            ).toLocaleString("en-US")}</div>
          </div>
          <div class="row mt-3">
            <div class="col-4 text-center">حسابات العملاء</div>
            <div class="col-4"></div>
            <div class="col-4 text-center">${
              reservation.unit.project.developer.name
            }</div>
          </div>
          <div class="text-center pt-5">
            وتفضلوا بقبول فائق الاحترام و التقدير ،،،،
          </div>
        </div>
      </div>
    </body>
  </html>
  `;
};



// WEBPACK FOOTER //
// ./src/app/financial/claims-view/claimPrint.ts